<template>
  <section>
    <div class="container">
      <!-- <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="navbar-nav JY-new-nav">
            <ul>
              <li class="sel"><em></em><a href="News/NewsList">公司动态</a><span></span></li>
              <li><a href="">行业动态</a></li>
              <li><a href="">交通动态</a></li>
            </ul>
          </div>
        </div>
      </div> -->
      <!-- <div class="row" style="margin-bottom: 60px;" >
        <div class="col-sm-4 col-lg-4">
          <blockquote class="blockquote">
            <img src="../../assets/images/va-new-a.png" alt="">
            
            <p class="mb-2">物流仓储论文参考</p>
            <span>2018-11-07</span>
            <small class="blockquote-footer">平台将面向广大车主或物流公司提供营运车辆的融资租赁服务，即由平台以更低廉实惠的 价格向专用汽车厂商指定的一级代理商购入营运 ...</small>
            <router-link to="list">
              了解更多 >
            </router-link>
          </blockquote>
        </div>
        <div class="col-sm-4 col-lg-4">
          <blockquote class="blockquote">
            <img src="../../assets/images/va-new-b.png" alt="">
            
            <p class="mb-2">物流仓储论文参考</p>
            <span>2018-11-07</span>
            <small class="blockquote-footer">平台将向广大车主或物流公司提供关于车、物流、人员的保险理赔增值服务，即公司通知整合多家具有实力的 保险公司（人保、太平洋、平安等）...</small>
            <a class="" href="">了解更多 ></a>
          </blockquote>
        </div>
        <div class="col-sm-4 col-lg-4">
          <blockquote class="blockquote">
            <img src="../../assets/images/va-new-c.png" alt="">
            
            <p class="mb-2">物流仓储论文参考</p>
            <span>2018-11-07</span>
            <small class="blockquote-footer">车辆维修是车主运输路途上经常会遇到的问题。 由于运输路径不固定，车主有时对当地的车辆维修点不熟悉。平台为方便车主出行和货物运输 ...</small>
            <a class="" href="">了解更多 ></a>
          </blockquote>
        </div>
      </div> -->

      <swapperList></swapperList>

    </div>

  </section>
</template>
<script>
import swapperList from "../../components/swapperList";

export default {
  components: {
    swapperList
  },
  data() {
    return {
      
      
    }
  },
  created(){

  },
  methods: {
    
  }
}
</script>
<style>
@import url("../../assets/css/JY-style-sonpage.css");
</style>




// WEBPACK FOOTER //
// src/pages/MessageCenter/News.vue